// extracted by mini-css-extract-plugin
module.exports = {"Score":"Score_Score__1PpKP","Correct":"Score_Correct__1WVmJ","Wrong":"Score_Wrong__3Hn7x"};